import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import Tippy from '@tippyjs/react';
import PropTypes from 'prop-types';

import { Icon } from '../Icons';

import './styles.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/dist/tippy.css';

const TooltipQuestion = ({ label }) => (
  <Tippy animation="fade" arrow content={label} interactive placement="bottom">
    {/* eslint-disable jsx-a11y/no-noninteractive-tabindex */}
    <span
      className="inline-block text-gray-4 focus:text-gray-6 hover:text-gray-6"
      data-testid="tooltip-span"
      tabIndex="0"
    >
      <Icon icon={faQuestionCircle} />
    </span>
    {/* eslint-enable jsx-a11y/no-noninteractive-tabindex */}
  </Tippy>
);

TooltipQuestion.propTypes = {
  /**
   * Text within tooltip.
   */
  label: PropTypes.string.isRequired,
};

export default TooltipQuestion;
